import { memo } from 'react'
import MultipleInputSkeleton from 'components/SkeletonView/MultipleInputSkeleton'

const EmploymentPositionSkeleton = () => <MultipleInputSkeleton count={2} />

export default memo(EmploymentPositionSkeleton)
